module.exports = __webpack_public_path__ + "static/img/アセット 88@3x.81290c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/アセット 88@3x.png
// module id = Y4kL
// module chunks = 1